// extracted by mini-css-extract-plugin
module.exports = {"root":"az_yH","--full-width":"az_zH"};